/* @flow */

import React from 'react';

import {svgIconWrapper} from '../svg-icon-wrapper';

import AvatarBlueSvg from './icon-avatar-blue.svg';

function SvgComponent(props) {
    const validProps = Object.assign({}, props);
    delete validProps.styles;

    return <AvatarBlueSvg {...validProps} />;
}
SvgComponent.iconName = 'avatarBlue';

export const AvatarBlueIcon = svgIconWrapper(SvgComponent);
